import React from 'react';
import { HeroSection } from './HeroSection';
import { PainSection } from './PainSection';
import { SolutionSection } from './SolutionSection';
import { BenefitsSection } from './BenefitsSection';
import { PurchaseSection } from './PurchaseSection';
export function LandingPage() {
  return <main className="min-h-screen bg-[#fafaf9] font-sans text-gray-900 selection:bg-[#4a7c2c] selection:text-white" data-id="element-45">
      <HeroSection data-id="element-46" />
      <PainSection data-id="element-47" />
      <SolutionSection data-id="element-48" />
      <BenefitsSection data-id="element-49" />
      <PurchaseSection data-id="element-50" />

      <footer className="bg-[#2d5016] text-white py-8 text-center text-sm opacity-90" data-id="element-51">
        <div className="container mx-auto px-4" data-id="element-52">
          <p data-id="element-53">
            © {new Date().getFullYear()} Guía para Hacer Esquejes. Todos los
            derechos reservados.
          </p>
        </div>
      </footer>
    </main>;
}